(function () {
  function isGif(url) {
    return url && url.toLowerCase().indexOf('.gif') !== -1;
  }

  function makePosterUrl(gifUrl) {
    // Shopify CDN: convert to jpg + limit width (keeps quality visually, massively smaller)
    // If URL already has ?v=, we append with &
    var sep = gifUrl.indexOf('?') >= 0 ? '&' : '?';
    return gifUrl + sep + 'format=jpg&width=600';
  }

  function swapToGif(img) {
    if (img.dataset.gifLoaded === '1') return;
    img.dataset.gifLoaded = '1';
    img.src = img.dataset.gifSrc;
  }

  function initOne(img) {
    var gifSrc = img.currentSrc || img.src;
    if (!isGif(gifSrc)) return;

    img.dataset.gifSrc = gifSrc;

    // Start with poster (fast)
    var poster = makePosterUrl(gifSrc);
    img.src = poster;
    img.srcset = ""; // avoid browser picking the gif from srcset
    img.loading = "lazy";
    img.decoding = "async";

    // Load GIF near viewport
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          io.disconnect();
          // wait a bit to avoid competing with LCP
          setTimeout(function(){ swapToGif(img); }, 800);
        }
      });
    }, { rootMargin: "300px 0px" });

    io.observe(img);

    // If user interacts quickly, allow earlier load
    ['pointerdown','touchstart','scroll','keydown'].forEach(function(ev){
      window.addEventListener(ev, function(){ swapToGif(img); }, { once:true, passive:true });
    });
  }

  function initAll() {
    document.querySelectorAll('img[data-gif-swap="1"]').forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', initAll);
})();
